import 'es6-promise/auto'
// require('intersection-observer')
import './misc/PublicPath'
import isEmpty from 'lodash/isEmpty'
import debounce from 'lodash/debounce'
import objectFitImages from 'object-fit-images'
import SiteHeader from './sitewide/SiteHeader'
import General from './sitewide/General'
import Home from './pages/Home'
import Blog from './pages/Blog'
import About from './pages/About'
import CartNotification from './components/CartNotification'
import SiteFooter from './sitewide/SiteFooter'
import CartPanel from './components/CartPanel'
import ProductCardAction from './components/ProductCardAction'
import ScrollAnimations from './misc/ScrollAnimations'
import Reviews from './components/Reviews'

class App {
    constructor() {
        this.bodyEl = document.body
        this.reloaders = []
        this.init()
        this.initResize()
    }

    init() {
        objectFitImages()
        this.loadInternalScripts()
    }

    loadInternalScripts() {
        new SiteHeader()
        new General()
        new SiteFooter()
        new CartPanel()
        new CartNotification()
        new ProductCardAction()
        new ScrollAnimations()
        new Reviews()

        if (this.bodyEl.classList.contains('template-index')) {
            new Home()
        }

        if (this.bodyEl.classList.contains('template-page-about')) {
            this.reloaders.push(new About())
        }

        if (this.bodyEl.classList.contains('template-blog')) {
            this.reloaders.push(new Blog())
        }

        if (this.bodyEl.classList.contains('template-page-contact')) {
            import('./pages/Contact').then((Contact) => new Contact.default())
        }

        if (
            this.bodyEl.classList.contains('template-collection') ||
            this.bodyEl.classList.contains('template-collection-hidden-offer') ||
            this.bodyEl.classList.contains('template-collection-grid')
        ) {
            import('./pages/Collection').then((Collection) => new Collection.default())
        }

        if (this.bodyEl.classList.contains('template-product') || this.bodyEl.classList.contains('template-product-simple')) {
            import('./pages/Product').then((Product) => new Product.default())
        }

        if (this.bodyEl.classList.contains('template-customers-login')) {
            import('./pages/AccountLogin').then((AccountLogin) => new AccountLogin.default())
        }

        if (this.bodyEl.classList.contains('template-page-our-quality')) {
            import('./pages/OurQuality').then((OurQuality) => new OurQuality.default())
        }

        if (this.bodyEl.classList.contains('template-page-delivery-returns') || this.bodyEl.classList.contains('template-page-account-delivery-return')) {
            import('./pages/DeliveryReturn').then((DeliveryReturn) => new DeliveryReturn.default())
        }

        if (this.bodyEl.classList.contains('template-page-coverage-calculator')) {
            import('./pages/CoverageCalculator').then((CoverageCalculator) => new CoverageCalculator.default())
        }

        if (this.bodyEl.classList.contains('template-page-safety-data-sheets')) {
            import('./pages/DataSheets').then((DataSheets) => this.reloaders.push(new DataSheets.default()))
        }

        if (this.bodyEl.classList.contains('template-search')) {
            import('./pages/Search').then((Search) => this.reloaders.push(new Search.default()))
        }

        if (this.bodyEl.classList.contains('template-customers-account')) {
            import('./pages/Account').then((Account) => new Account.default())
        }

        if (this.bodyEl.classList.contains('template-page-account-details')) {
            import('./pages/AccountDetails').then((AccountDetails) => new AccountDetails.default())
        }

        if (this.bodyEl.classList.contains('template-cart')) {
            import('./pages/Cart').then((Cart) => new Cart.default())
            import('./components/CartProductRecommendations').then((CartProductRecommendations) => new CartProductRecommendations.default())
        }

        if (this.bodyEl.classList.contains('template-article')) {
            import('./pages/Article').then((Article) => new Article.default())
        }

        if (this.bodyEl.classList.contains('template-page-wishlist')) {
            import('./pages/Wishlist').then((Wishlist) => new Wishlist.default())
        }
    }

    initResize() {
        if (!isEmpty(this.reloaders)) {
            window.addEventListener(
                'resize',
                debounce(() => {
                    this.resize()
                }, 150),
                false
            )
        }
    }

    resize() {
        this.reloaders.forEach((element) => {
            if (typeof element.resize === 'function') {
                element.resize()
            }
        })
    }
}

new App()
